// This id is required to ensure pollinator tests work between Nav3 and Nav4 and also in feature tests
export const GLOBAL_CREATE_BUTTON_NAV4 = 'atlassian-navigation--create-button';
// Once the jira_aifc_enabled feature gate is enabled, this will be replaced with GLOBAL_CREATE_BUTTON_NAV4
export const GLOBAL_CREATE_SPLIT_BUTTON = 'atlassian-navigation--create-split-button';
// Universal Create button wrapper
export const GLOBAL_CREATE_BUTTON_WRAPPER =
	'atlassian-navigation.ui.universal-create.universal-create-wrapper';
export const UNIVERSAL_CREATE_BUTTON_ID = 'universalCreate';
